(function () {
    "use strict";

    // @ngInject
    function BrochureSectionsModalControllerCtor($modalInstance, $scope, _, $injector, AnalyticsService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'BrochureSectionsModalController';
        this.$modalInstance = $modalInstance
        AnalyticsService.trackPageView(this, 'brochure_sections_layout_modal');

    }

    Controllers.BrochureSectionsModalController = Class(Controllers.BaseController, {
        constructor: BrochureSectionsModalControllerCtor,

        onLayoutSelect: function onLayoutSelect(layoutType) {
            this.$modalInstance.close(layoutType);
        },

        dismiss: function dismiss() {
            this.$modalInstance.dismiss();
        },

    });
}());
